import React, { useEffect } from "react";
import { Switch, Route, withRouter } from "react-router-dom";
import classnames from "classnames/bind";
import { fire } from "src/utils/Firebase.js";

import css from "./index.scss";
import routes from "./routes";

const cx = classnames.bind(css);
const moduleName = "App";

const App = () => {
  useEffect(() => {
    fire();
  }, []);

  return (
    <div className={cx(`${moduleName}`)}>
      <Switch>
        {routes.map(({ ...routeProps }) => (
          <Route {...routeProps} key={routeProps.path || ""} />
        ))}
      </Switch>
    </div>
  );
};

export default withRouter(App);



// WEBPACK FOOTER //
// ./src/App/index.js